module.exports = __webpack_public_path__ + "static/media/add_icon.5e7d88c8.svg";